import { Link } from "react-router-dom";
import { MessageSquare, Users } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import { MemberList } from "@/components/offers/GroupMembersField";

// Client dashboard: the payer sees his group's members (changes are requested by message); a member sees he is covered.
export const GroupCard = ({ billing }) => {
  const { t, fmtDate } = useI18n();
  const g = billing?.group;
  if (!g && !billing?.group_member) return null;
  return (
    <section className="card-carbon min-w-0 space-y-3 rounded-2xl p-5" data-testid="client-group-card">
      <h2 className="flex min-w-0 items-center gap-2 break-words font-display text-sm font-bold uppercase tracking-wider text-emerald-200">
        <Users className="h-5 w-5 shrink-0" /> {g ? t("group.sites", { n: g.members.length, size: g.size }) : t("group.memberTitle")}
      </h2>
      {g ? (
        <>
          <MemberList members={g.members} testId="client-group-members" />
          {g.until && <p className="text-xs text-neutral-400" data-testid="client-group-until">{t("group.until", { date: fmtDate(g.until) })}</p>}
          <Link to="/espace-developpeur/messages?nouveau=custom" className="btn-red btn-sm max-w-full whitespace-normal text-start" data-testid="client-group-request-change">
            <MessageSquare className="h-4 w-4 shrink-0" /> {t("group.requestChange")}
          </Link>
        </>
      ) : <p className="break-words text-sm text-neutral-300" data-testid="client-group-member-note">{t("group.memberNote")}</p>}
    </section>
  );
};
